<template>
    <div>
        {{$t('teams_apps.welcome_to_apprentice_please_wait_one_moment_while_we_direct_you_to_the_right_page')}}.
    </div>
</template>

<script>

import {app, authentication} from "@microsoft/teams-js";

export default {
    name: "teams-landing-component",
    mounted() {
        app.initialize();
        app.getContext().then((success) => {
            authentication.getAuthToken().then((result) => {
                const params = {
                    token: result,
                    teams_team_id: success.page ? success.page.id : null
                }
                window.location = this.routes.teamsRedirect(params);
            })
        })
    }
}
</script>

<style scoped>

</style>
